import React, { Fragment } from "react";
import {FormattedMessage} from "react-intl";

import TextInput from "../../ui/textInput";
import {setAiRenderOptions} from "../aiActions";
import {useAppDispatch, useAppSelector} from "../../../storeHooks";

const selectModelItems = [
  {value: "gpt-5.4-nano", text: "GPT 5.4 Nano"},
  {value: "gpt-5.1-chat-latest", text: "GPT 5.1 (Chat Latest)"},
  {value: "gpt-5.1", text: "GPT 5.1 Thinking"},
  {value: "gpt-5-nano", text: "GPT-5 Nano (Fastest)"},
  {value: "gpt-5-mini", text: "GPT-5 Mini (Balanced)"},
  {value: "gpt-5", text: "GPT-5 (Best Quality)"},
  {value: "gpt-4o-mini", text: "GPT-4o Mini (Legacy Fast)"},
  {value: "gpt-4o", text: "GPT-4o (Legacy High Quality)"},
  {value: "custom", text: "Custom..."},
]

const selectImageItems = [
  {value: "gpt-image-1", text: "GPT Image 1"},
  {value: "gpt-image-1.5", text: "GPT Image 1.5"},
  {value: "gpt-image-2", text: "GPT Image 2"},
  {value: "gpt-image-2.5-sunburst", text: "GPT Image 2.5 Sunburst"},
  {value: "gpt-image-2.5-flare", text: "GPT Image 2.5 Flare"},
  {value: "gemini-3.1-flash-image", text: "Gemini 3.1 Flash Image (Nano Banana 2)"},
  {value: "custom", text: "Custom..."},
]

const renderOptionCheckboxes: {
  property: string;
  label: string;
  enabledWhen: string | null;
  checkedGuard: string | null;
}[] = [
  { property: "aiEnableThumbnailImages",              label: "Add Thumbnails:",            enabledWhen: null,                     checkedGuard: null },
  { property: "aiEnableReferenceImage",               label: "Add Reference:",             enabledWhen: null,                     checkedGuard: null },
  { property: "aiSendAsPNG",                          label: "Reference As PNG:",          enabledWhen: "aiEnableReferenceImage", checkedGuard: "aiEnableReferenceImage" },
  { property: "aiSendOnlySelectedGroupsAsAReference", label: "Send Only Selected Groups:", enabledWhen: "aiEnableReferenceImage", checkedGuard: "aiEnableReferenceImage" },
  { property: "aiSendCombinedThumbnails",             label: "Send Combined Thumbnails:",  enabledWhen: null,                     checkedGuard: null },
];

export default function UiPopupAIContentDropdowns() {

  const aiRenderOptions = useAppSelector(state => state.aiState.aiRenderOptions);

  const {selectedChatModel, customChatModel, selectedImageModel, customImageModel} = aiRenderOptions;

  const dispatch = useAppDispatch();

  const onModelChange = (event) => {
    dispatch(setAiRenderOptions({
      selectedChatModel: event.target.value,
    }));
  }

  const onImageChange = (event) => {
    dispatch(setAiRenderOptions({
      selectedImageModel: event.target.value,
    }));
  }

  const isCustomModel = selectedChatModel === "custom";

  return (
    <div className="u-mb-1 flex flex--column flex--top u-gap-075">
      <div className="flex flex--start gap-2">
        <select name=""
                className={"ui-input ui-input--new ui-input--select !w-[270px] !transition-none"
                  + (!selectedChatModel ? " ass-field__input--no-value" : "")}
                value={selectedChatModel ?? ""}
                onChange={onModelChange}>
          <option value="" disabled hidden>
            Select Model
          </option>
          {selectModelItems.map((selectItem) => {
            return <option key={selectItem.value} value={selectItem.value}>{selectItem.text}</option>
          })}
        </select>
        <select name=""
                className={"ui-input ui-input--new ui-input--select !w-[270px] !transition-none"
                  + (!selectedImageModel ? " ass-field__input--no-value" : "")}
                value={selectedImageModel ?? ""}
                onChange={onImageChange}>
          <option value="" disabled hidden>
            Select Image
          </option>
          {selectImageItems.map((selectItem) => {
            return <option key={selectItem.value} value={selectItem.value}>{selectItem.text}</option>
          })}
        </select>
      </div>
      {isCustomModel || selectedImageModel === "custom" || selectedImageModel === "custom" ? (
        <div className="flex flex--start gap-2">
          <Fragment>
            {isCustomModel || selectedImageModel === "custom" ? (
              <TextInput
                className={"ui-input ui-input--new ui-input--select !w-[270px]"
                  + (selectedChatModel !== "custom" ? " ui-input--gray" : "")}
                name={"customChatModel"}
                value={isCustomModel ? customChatModel || "" : ""}
                disabled={selectedChatModel !== "custom"}
                onChange={(val) => dispatch(setAiRenderOptions({customChatModel: val}))}
                autoFocus={isCustomModel}
              />
            ) : null}
            {selectedImageModel === "custom" ? (
              <TextInput
                className={"ui-input ui-input--new ui-input--select !w-[270px]"}
                name={"customImageModel"}
                value={customImageModel || ""}
                onChange={(val) => dispatch(setAiRenderOptions({customImageModel: val}))}
                autoFocus
              />
            ) : null}
          </Fragment>
        </div>
      ) : null}
      <div className="flex flex--start gap-2">
        {renderOptionCheckboxes.map(({ property, label, enabledWhen, checkedGuard }, index) => {
          const isEnabled = enabledWhen ? !!aiRenderOptions[enabledWhen] : true;
          const isChecked = (checkedGuard ? !!aiRenderOptions[checkedGuard] : true) && !!aiRenderOptions[property];
          return (
            <div key={property}
                 className={"flex flex--column flex--top "
                   + (index ? " padding-l-15 border-0 border-l border-solid border-[#e2e2e2]" : "")
                   + (isEnabled ? "" : " disabled2 cursor-default")}>
              <span className="ui-radio-label nowrap">{label}</span>
              <button className={"ui-radio ui-radio--small" + (isChecked ? " ui-radio--checked" : "")}
                      onClick={isEnabled ? () => dispatch(setAiRenderOptions({
                        [property]: !aiRenderOptions[property]}
                      )) : null}>
                <span className="ui-radio-circle"/>
                <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
                <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  )
}
